import { useMemo } from "react";
import type { NurseFullRole } from "../utils/models";
import { getDepartmentNurseTypes } from "../utils/utilFunctions";
import { useDepartmentById } from "./useDepartmentById";
import { useDepartmentStaff } from "./useDepartmentStaff";

/**
 * The roles a department's staff can hold: its configured roles plus any role someone on its roster holds. Takes the
 * department id so the ops backoffice drill-down reads the drilled department, not the one chosen in the header.
 * Grows once the roster loads — callers that keep a selection should keep "all" undefined rather than a copy.
 */
export const useDepartmentNurseTypes = (departmentId: string): NurseFullRole[] => {
	const department = useDepartmentById(departmentId);
	const { staff: roster } = useDepartmentStaff(departmentId);
	// DEFAULT: no configured roles for a department the user's list lacks (useDepartmentById tracks it), and no roster
	// roles until the roster loads — the roles held on the roster still show once it does.
	return useMemo(() => getDepartmentNurseTypes(department?.roles ?? [], roster ?? []), [department?.roles, roster]);
};
